import { cartHandler } from "../handlers/cartHandler";
import { bfslHandler } from "../handlers/bfslHandler";
import { SSORedirectArgs, SSOURLConfigs } from "../types/SSO.types";
import { myAccountHandler } from "../handlers/myAccountHandler";

export const ssoHandlerMap = {
  cart: cartHandler,
  bfsl: bfslHandler,
  myaccount: myAccountHandler,
} as const;

export type HandlerNames = keyof typeof ssoHandlerMap;

/**
 * callHandler
 */
export const callHandler = (mapping: SSOURLConfigs, data: SSORedirectArgs) => {
  try {
    if (mapping.ssoModule) {
      ssoHandlerMap[mapping.ssoModule as HandlerNames](data);
    } else {
      console.warn("ssoModule is null or undefined");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
